import { IPathfindingGoalCondition } from "./IPathfindingGoalCondition";
import { PathfindingGraph } from "./PathfindingGraph";

/**
 * A goal condition for the Pathfinder that is satisfied at one single pair of coordinates.
 * @author npuschke
 *
 */
export class PathfindingGoalConditionTargetPoint implements IPathfindingGoalCondition {
    private _targetX: number;
    private _targetY: number;

    /**
     * Creates a GoalCondition that is satisfied at the given coordinates.
     * @param targetX The horizontal coordinate of the target node.
     * @param targetY The vertical coordinate of the target node.
     *
     */
    constructor(targetX: number, targetY: number) {
        this._targetX = targetX;
        this._targetY = targetY;
    }

    /**
     * Determines whether this goal condition is satisfied at the given coordinates.
     * @param x The horizontal coordinate of the potential target node.
     * @param y The vertical coordinate of the potential target node.
     * @return <code>true</code> if the node is the target; <code>false</code> otherwise.
     *
     */
    public isSatisfied(x: number, y: number): boolean {
        return (x == this._targetX && y == this._targetY);
    }

    /**
     * Roughly checks if the goal condition is satisfied for any node in the graph at all. If not, the path search can be aborted early.
     * @param graph The graph that will be searched.
     * @return <code>true</code> if no node satisfies the goal condition; <code>false</code> otherwise.
     *
     */
    public isUnreachable(graph: PathfindingGraph): boolean {
        return !graph.hasNodeAtPosition(this._targetX, this._targetY);
    }
}
